import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

export const getGaLabelByNavigationType = (offer: ISpecOffer): string => {
    const prefix = ' | type:';
    const { navigation, benefits } = offer;

    if (navigation?.type) {
        switch (navigation.type) {
            case 'equipment':
                return `${prefix}equipment`;
            case 'multisubscription':
                return `${prefix}multisubscription`;
            case 'promoPacket':
                return `${prefix}tariff`;
            case 'speedBonusWithRequest':
                return `${prefix}speed_bonus_with_request`;
            case 'pendingConnection':
                return '';
        }
    } else {
        const needPhoneBenefitIndex = benefits?.findIndex(benefit => !!benefit.needPhone);

        if (!benefits || needPhoneBenefitIndex === -1) {
            return `${prefix}ordinary`;
        } else {
            return `${prefix}with_phone_number`;
        }
    }
};
